module.exports = __webpack_public_path__ + "static/media/splotch.b1d7bf8e.svg";